import { Routes, Route } from "react-router-dom";
import MainNavbar from "./components/MainNavbar.jsx";
import LandingPage from "./pages/LandingPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import RegistrationPage from "./pages/RegistrationPage.jsx";
import HomePage from "./pages/Home.jsx";
import Profile from "./pages/Profile.jsx";
import PageNotFound from "./pages/404Page.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import ResumeEditor from "./pages/ResumeEditor.jsx";
import ResumeCreator from "./pages/ResumeCreator.jsx";
import ResumeViewer from "./pages/ResumeViewer.jsx";
import SVCFooter from "./components/SVCFooter.jsx";
import OpeningManager from "./pages/OpeningManager.jsx";
import { AuthProvider } from "./helpers/auth.js";

export default function App() {
  return (
    <AuthProvider>
      <MainNavbar />
      <SVCFooter />
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registration" element={<RegistrationPage />} />
        <Route exact path="*" element={<PageNotFound />} />
        <Route exact path="/" element={<ProtectedRoute><LandingPage /></ProtectedRoute>}> </Route>
        <Route exact path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>}> </Route>
        <Route exact path="/resumeCreator" element={<ProtectedRoute><ResumeCreator /></ProtectedRoute>}> </Route>
        <Route exact path="/resumeEditor" element={<ProtectedRoute><ResumeEditor /></ProtectedRoute>}> </Route>
        <Route exact path="/resumeViewer" element={<ProtectedRoute><ResumeViewer /></ProtectedRoute>}> </Route>
        <Route exact path="/resumeViewer/:resumeId" element={<ProtectedRoute><ResumeViewer /></ProtectedRoute>}> </Route>
        <Route exact path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>}> </Route>
        <Route exact path="/openingManager" element={<ProtectedRoute><OpeningManager /></ProtectedRoute>}> </Route>
      </Routes>
    </AuthProvider>
  );
}
